import React from 'react';

import { Container, MainSection, CardMainText, Details } from 'basics/cards';

import ItemCardToolBar from 'components/ItemCardToolBar';

import LogoIcon from 'icons/entities/LogoIcon';

export default function CompetitionCard({ item, selected, onSelectEditedItem, onSelectDeletedItem, onCleanItemId, onReactivateItem }) {
	
	return (
		<Container selected={selected}>
			<MainSection>
				<LogoIcon />
				<Details>
					<CardMainText>{item.title}</CardMainText>
				</Details>
			</MainSection>

			<ItemCardToolBar id={item.id} actived={item.actived} selected={selected} onCleanItemId={onCleanItemId} onSelectEditedItem={onSelectEditedItem} onSelectDeletedItem={onSelectDeletedItem} onReactivateItem={onReactivateItem}/>

		</Container>
	);
}
